module.exports = __webpack_public_path__ + "5934435c7f39b5c1a8d588f4be46e982.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/yemen.jpg
// module id = 608
// module chunks = 0